export default __webpack_public_path__ + "static/media/img5.47ec6802.png";